import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { NotificationService } from './notification.service';
import { GeneralConstants } from '../constants/general.constants';

@Injectable({
  providedIn: 'root'
})
export class MyCommerceService {
  constructor(private restService: RestService, private notificationService: NotificationService) {}

  public getSucursal = async (id: string) => {
    try {
      const response = await this.restService.get(`${GeneralConstants.getInfoSucursal}${id}`);
      return response.object;
    } catch (error) {
      return this.notificationService.mgsView({
        error: 404,
        messenger: error.message,
        title: 'Sucursal',
        type: 2,
        configNotification: null
      });
    }
  };

  public getResponsible = async (id: string) => {
    try {
      const response = await this.restService.get(`${GeneralConstants.getInfoResponsible}${id}`);
      return response.object;
    } catch (error) {
      return this.notificationService.mgsView({
        error: 404,
        messenger: error.message,
        title: 'Responsable',
        type: 2,
        configNotification: null
      });
    }
  };

  public getCashier = async (cajaId, sucursalId) => {
    try {
      const response = await this.restService.get(`${GeneralConstants.getInfoPuestoCobro}${sucursalId}/caja/${cajaId}`);
      return response.object;
    } catch (error) {
      return this.notificationService.mgsView({
        error: 404,
        messenger: error.message,
        title: 'Caja',
        type: 2,
        configNotification: null
      });
    }
  };
}
